<template>
    <div class="footer">
        <p>Copyright © 2019 北京康伊医疗科技有限责任公司. All rights reserved.</p>
    </div>
</template>

<style lang="scss" scoped>
    @import './foot.scss';
</style>

<script>
    export default {
        data() {
            return {

            }
        },
        components: {

        },
        mounted() {

        },
        methods: {

        },
    }
</script>